// tabs.js
;(({ $, $$ }) => {
    const tabActiveClass = 'tab_active'
    const contentActiveClass = 'tabs-content__section_active'

    const tabsButtonsAll = $$('.tabs-buttons')
    const tabsContentAll = $$('.tabs-content')

    tabsButtonsAll.forEach(handleTabButtons)

    function handleTabButtons(tabButtons) {
        const initIndex = tabButtons.dataset.tabsInitIndex
        const tabGroup = tabButtons.dataset.tabsGroup

        const tabsContent = getTabsContent(tabsContentAll, tabGroup)
        if (!tabsContent) return

        const allContentSections = Array.from(
            tabsContent.querySelectorAll('.tabs-content__section')
        )

        const allTabs = Array.from(tabButtons.querySelectorAll('.tabs-buttons__tab'))

        allTabs.forEach(tab => {
            if (tab) {
                tab.addEventListener('click', () => {
                    if (!tab.classList.contains(tabActiveClass)) {
                        resetTabs(allTabs, allContentSections)
                        const index = allTabs.indexOf(tab)
                        tab.classList.add(tabActiveClass)
                        allContentSections[index].classList.add(contentActiveClass)
                    }
                })
            }
        })

        allTabs[initIndex].click()
    }

    // Find tabs content with specific group
    function getTabsContent(allContent, groupName) {
        let tabContent = null
        allContent.forEach(content => {
            if (content.dataset.tabsGroup === groupName) {
                tabContent = content
                return
            }
        })
        return tabContent
    }

    function resetTabs(tabs, content) {
        tabs.forEach(tab => {
            if (tab) {
                tab.classList.remove(tabActiveClass)
            }
        })
        content.forEach(cnt => {
            if (cnt) {
                cnt.classList.remove(contentActiveClass)
            }
        })
    }
})(CNS)
